export default defineNuxtPlugin(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
        return
    }

    // The maintenance service worker was retired. Unregister any lingering
    // registration from previous app versions so it stops controlling the page.
    navigator.serviceWorker
        .getRegistrations()
        .then(registrations => registrations.forEach(registration => registration.unregister()))
        .catch(() => {
            // no-op: cleanup is best-effort
        })
})
